import React, { useEffect, useState } from 'react';
import { Field, Form, Formik } from 'formik';
import { Box, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import Yup from '../../../utils/yup';
import { WmsType } from '../../../config/wms/wmsType';
import { AutoCompleteSelectUI, ButtonUI, FormErrorUI, FormLabelUI } from '../../Interface';
import masterDataService from '../../../service/masterData.service';
import { generateAutocompleteItems } from '../../../utils/helper';
import wmsBaseService from '../../../service/wms/wmsBase.service';

const NewInventoryTransfer = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const ui = theme.palette.ui;
  const defaultHead = {
    whsCode: '',
  };

  const validationSchema = Yup.object().shape({
    whsCode: Yup.string().required(),
  });

  const [autocompleteOptions, setAutoCompleteOptions] = useState({
    warehouse: [],
  });
  const [autocompleteData, setAutoCompleteData] = useState({
    warehouse: [],
  });

  const getInitData = async () => {
    const [wareHouse] = await Promise.all([masterDataService.warehouseToForm()]);

    setAutoCompleteOptions({
      warehouse: generateAutocompleteItems(wareHouse, 'code', 'code'),
    });

    setAutoCompleteData({
      warehouse: wareHouse,
    });
  };

  useEffect(() => {
    getInitData();
  }, []);

  const handleSubmit = async (values) => {
    const response = await wmsBaseService.createData({ ...values, wmsType: WmsType.InventoryTransfer });

    navigate(`../inventoryTransferDoc/${response.id}`);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, py: 4, px: 2, width: '100%' }}>
      <Formik
        initialValues={defaultHead}
        validationSchema={validationSchema}
        validateOnChange={false}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ values, errors, setFieldValue, isSubmitting }) => (
          <Form>
            <Field
              type="autocomplete"
              name="whsCode"
              component={AutoCompleteSelectUI}
              fullWidth
              label={<FormLabelUI text="Raktár" />}
              variant="standard"
              helperText={<FormErrorUI message={errors.whsCode} />}
              InputLabelProps={{ shrink: Boolean(values.whsCode) }}
              onChange={(_e, newVal) => setFieldValue('whsCode', newVal?.value ?? null)}
              selectedValue={values.whsCode}
              selectedLabelValue={autocompleteData?.warehouse?.find((p) => p.code === values.whsCode)?.code}
              dataset={autocompleteOptions?.warehouse}
            />

            <Box
              sx={{
                display: 'flex',
                gap: 3,
                justifyContent: 'center',
                py: 1,
              }}
            >
              <ButtonUI
                text="Indítás"
                className="flex gap-2 items-center"
                style={{ background: ui.addButton }}
                type={'submit'}
                disabled={isSubmitting}
              >
                Rögzítés
              </ButtonUI>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default NewInventoryTransfer;
